import { SecurityDomainDto } from '@repo/shared/dtos/SecurityDomainDto';
import { redirect } from '@tanstack/react-router';

export const getSecurityDomain = async (domain: SecurityDomainDto) => {
  const params = new URLSearchParams();
  if (domain.routeObject) params.set('routeObject', domain.routeObject);

  if (domain.routeItem) params.set('routeItem', domain.routeItem);

  if (domain.action) params.set('action', domain.action);

  const response = await fetch(`/api/auth/domain?${params.toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  });

  return response;
};

export const checkSecurityDomain = (domain: SecurityDomainDto) => async () => {
  const response = await getSecurityDomain(domain);

  if (!response.ok || !(await response.json()).isAllowed) {
    throw redirect({
      to: '/',
    });
  }
};
